import TextField from "./TextField";
import Button from "./Button";
import React from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const searchFormSchema = yup.object({
  keyword: yup.string(),
});

export type SearchFormDataType = yup.InferType<typeof searchFormSchema>;

interface Props {
  onChange: (val: string) => void;
}

const SearchBar = ({ onChange }: Props) => {
  const searchFormMethods = useForm<SearchFormDataType>({
    resolver: yupResolver(searchFormSchema),
    defaultValues: {
      keyword: "",
    },
  });

  const search: SubmitHandler<SearchFormDataType> = (data) => {
    onChange(data.keyword || "");
  };

  return (
    <form
      className="gpc__search-box__group"
      onSubmit={searchFormMethods.handleSubmit(search)}
    >
      <Controller
        name="keyword"
        control={searchFormMethods.control}
        render={({ field: { onChange, value } }) => (
          <TextField
            onChange={onChange}
            value={value}
            placeholder="Search your orders"
          />
        )}
      />

      <Button active type="submit">
        Search
      </Button>
    </form>
  );
};

export default SearchBar;
